import TripExtraInfosFormContainer from './TripExtraInfosFormContainer';

export default TripExtraInfosFormContainer;
